// Keep the editor dependency graph off pages that only display directories.
// Propshaft fingerprints the standalone runtime for cloud and self-hosted builds.
export function attachRichtext(application, { root = document, load = url => import(url), observe = callback => new MutationObserver(callback) } = {}) {
  const selector = '[data-controller~="markdown-editor"], [data-controller~="markdown-viewer"]'
  let pending
  let observer
  let registered = false
  let retries = 0

  function ensureLoaded() {
    if (!pending) {
      const asset = RAILS_ASSET_URL('/richtext_runtime.js')
      const url = retries ? `${asset}${asset.includes('?') ? '&' : '?'}retry=${retries}` : asset
      pending = load(url).then(module => {
        application.register('markdown-editor', module.editor)
        application.register('markdown-viewer', module.viewer)
        registered = true
        observer?.disconnect()
        root.querySelectorAll('[data-richtext-error]').forEach(node => node.remove())
      }).catch(error => {
        pending = null
        retries += 1
        throw error
      })
    }
    return pending
  }

  function scan(node) {
    if (registered || node.nodeType !== 1 && node !== root) return
    const elements = [...node.querySelectorAll(selector)]
    if (node.matches?.(selector)) elements.unshift(node)
    if (!elements.length) return
    ensureLoaded().catch(error => {
      console.error('Rich-text editor could not load', error)
      for (const element of elements) {
        if (!element.isConnected || element.querySelector('[data-richtext-error]')) continue
        const message = root.createElement('div')
        message.dataset.richtextError = ''
        message.setAttribute('role', 'alert')
        message.textContent = 'Rich text could not load. Your content is still available. '
        const retry = root.createElement('button')
        retry.type = 'button'
        retry.className = 'btn btn-sm btn-ghost'
        retry.textContent = 'Retry editor'
        retry.addEventListener('click', () => { message.remove(); scan(element) })
        message.append(retry)
        element.append(message)
      }
    })
  }

  scan(root)
  observer = observe(mutations => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes') scan(mutation.target)
      else for (const node of mutation.addedNodes) scan(node)
    }
  })
  observer.observe(root.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-controller'] })
}
